import React from "react";
import { Typography } from "@mui/material";
import LegalLayout from "../components/LegalLayout";

export default function Privacy() {
    return (
        <LegalLayout title="Privacy Policy" updatedDate="July 18, 2026">
            <Typography component="p">
                This Privacy Policy explains how Kodex Shielding Solutions collects, uses,
                and protects information in connection with the employee and subcontractor
                portal (the "Portal"). The Portal is an internal system intended for
                authorized users only; this policy does not apply to the general public.
            </Typography>

            <Typography component="h2">1. Information We Collect</Typography>
            <Typography component="p">
                In the course of operating the Portal, we collect information you provide
                or generate while using it, including:
            </Typography>
            <ul>
                <li>
                    <Typography component="span">
                        Account information such as your name, username, email address, and
                        profile photo;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Work records such as timesheets, work type, hours, projects assigned,
                        and field or shop activity;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Expense and mileage records, including company card and reimbursable
                        expense submissions;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Engineering, project, and reporting data you create or upload
                        (documents, ECNs, incident and service reports, etc.);
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Project, customer, and vendor accounting data (such as job names,
                        billing addresses, estimates, and costs) connected to our QuickBooks
                        Online integration, described in Section 4 below;
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Technical information such as login timestamps and device/browser
                        information used to secure your account.
                    </Typography>
                </li>
            </ul>

            <Typography component="h2">2. How We Use Information</Typography>
            <Typography component="p">
                Information collected through the Portal is used to operate company
                business functions, including payroll and timekeeping, expense
                reimbursement, project and field scheduling, engineering recordkeeping,
                reporting, and account security. Information is not sold or used for
                advertising.
            </Typography>

            <Typography component="h2">3. Sharing of Information</Typography>
            <Typography component="p">
                Information is shared internally with managers, administrators, and other
                personnel who need it to perform their job duties (for example, approving
                timesheets or expenses). Information may also be shared with third-party
                service providers that support Portal operations (such as hosting and the
                QuickBooks Online accounting integration described below), and disclosed
                where required by law.
            </Typography>

            <Typography component="h2">4. QuickBooks Online Integration</Typography>
            <Typography component="p">
                A company administrator may connect the Portal to QuickBooks Online, an
                accounting service provided by Intuit Inc., using Intuit's standard
                authorization (OAuth) process. This connection is limited to QuickBooks'
                accounting scope and can be disconnected by an administrator at any time.
            </Typography>
            <Typography component="p">
                When connected, the Portal exchanges the following information with
                QuickBooks Online for the sole purpose of keeping project accounting
                records in sync:
            </Typography>
            <ul>
                <li>
                    <Typography component="span">
                        Sent to QuickBooks Online: customer and project ("job") names and
                        billing/shipping addresses, project cost estimates, project cost
                        totals (materials, labor, expenses, and services), and vendor
                        information (company name, tax ID, contact name, email, phone, and
                        address);
                    </Typography>
                </li>
                <li>
                    <Typography component="span">
                        Read back from QuickBooks Online: vendor lists (to match or import
                        vendor records) and invoice/estimate totals (to reconcile billed
                        amounts against project records).
                    </Typography>
                </li>
            </ul>
            <Typography component="p">
                Employee timesheets, expense reports, mileage records, and other personal
                work records are not sent to QuickBooks Online. Use of QuickBooks Online
                data obtained through this integration is limited to the accounting and
                project-reconciliation purposes described above, consistent with Intuit's
                Developer Terms of Service.
            </Typography>

            <Typography component="h2">5. Data Retention</Typography>
            <Typography component="p">
                Records such as timesheets, expenses, and project documentation are
                retained for as long as necessary to comply with business, tax, and legal
                recordkeeping requirements, and are handled in accordance with company
                policy after your account is deactivated.
            </Typography>

            <Typography component="h2">6. Data Security</Typography>
            <Typography component="p">
                We use reasonable administrative and technical safeguards, including access
                controls and authenticated login, to protect information stored in the
                Portal. You are responsible for keeping your login credentials
                confidential and reporting any suspected unauthorized access.
            </Typography>

            <Typography component="h2">7. Your Choices</Typography>
            <Typography component="p">
                You may update certain account information, such as your profile photo,
                directly in the Portal. For questions about other information associated
                with your account, contact your manager or the administrative team.
            </Typography>

            <Typography component="h2">8. Changes to This Policy</Typography>
            <Typography component="p">
                This Privacy Policy may be updated from time to time. Material changes will
                be reflected by updating the "Last updated" date above.
            </Typography>

            <Typography component="h2">9. Contact</Typography>
            <Typography component="p">
                Questions about this Privacy Policy should be directed to your manager or
                the Kodex Shielding Solutions administrative team.
            </Typography>
        </LegalLayout>
    );
}
